<template>
  <div>
    <!-- toolbar -->
    <el-row class="btn-top-area">
      <el-col :span="12"><el-button size="small" @click="showEventList">목록보기</el-button></el-col>
      <el-col :span="12">
        <div class="align-right">
          <el-button icon="fas fa-caret-left" size="small" v-show="preBtnFlag" @click="clickForChangeTargetGroup('pre')"></el-button>
          <el-button icon="fas fa-caret-right" size="small" v-show="nexBtnFlag" @click="clickForChangeTargetGroup('nex')"></el-button>
        </div>
      </el-col>
    </el-row>
    <!-- Contents -->
    <el-row class="mr-b25">
      <el-col :span="24">
        <table class="list-another02">
          <tr>
            <th>
              <span class="de-list">
                {{ eventInfo.eventInfo.eventName }}
              </span>
            </th>
            <td>
              <span class="txt-space">{{ getDateToString(eventInfo.checkDatetime, 'YYYY-MM-DD HH:mm:ss') }}</span>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row class="list-dot-tit mr-b30">
      <strong class="list-tit"><span>알람 요약</span></strong>
      <el-row type="flex" class="list form-list" justify="space-between">
        <el-col class="mr-r20" :span="12">
          <el-form ref="form" label-position="left">
              <el-form-item label="발생 시각" label-width="120px">{{ getDateToString(eventInfo.checkDatetime, 'YYYY-MM-DD HH:mm:ss') }}</el-form-item>
              <el-form-item label="알람명" label-width="120px">{{ eventInfo.eventInfo.eventName }}</el-form-item>
              <el-form-item label="발생 조건" label-width="120px">
                {{ eventInfo.eventConditionLabel }}
              </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form ref="form" label-position="left">
              <el-form-item label="이벤트 등급" label-width="120px">
                <!-- <w-eventlevel-cell :eventlevel-id="eventInfo.eventlevelId"></w-eventlevel-cell> -->
                {{ eventInfo.eventlevelName }}
              </el-form-item>
              <el-form-item label="알람 종류" label-width="120px">{{ eventInfo.eventTypeLabel }}</el-form-item>
              <el-form-item label="발생 값" label-width="120px">{{ eventInfo.eventOccurValueLabel }}</el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-row>
    <el-row class="list-dot-tit mr-b30" v-if="eventInfo != null && eventInfo.eventInfo.eventType === 'BASELINE'">
      <strong class="list-tit"><span>발생 원인</span></strong>
        <w-detail-event-chart :event-info="eventInfo" />
    </el-row>
    <el-row class="list-dot-tit mr-b30"
      v-else-if="eventInfo != null && (eventInfo.eventInfo.eventType === 'KEYWORD_COUNT' || eventInfo.eventInfo.eventType === 'UNKNOWN_PATTERN' || eventInfo.eventInfo.eventType === 'ML_PATTERN')">
      <strong class="list-tit"><span>로그 메시지</span></strong>
      <el-table-wrapper :column-default="columnDefault" :data="eventLogs" :columns="eventLogColumns" :pagination="false" max-height="300"
        :show-custom-header="false" header-align="center" highlight-current-row>
        <template slot-scope="scope" slot="log-detail-slot">
          <span class="c-pointer" @click="openDetailPopup(scope.row)">
            <i class="far fa-search-plus"/>
          </span>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-log-detail-popup ref="logDetailPopup" />
    <w-detail-event-comment :event-info="eventInfo" />
    <w-detail-event-hist :event-info="eventInfo" />
  </div>
</template>

<script>
import { isEmpty, clone, forEach, isNil } from 'lodash';
import msgUtil from '@/utils/message';
import LogAPI from '@/api/log/integrated-log';
import { getIntervalDatetimeParams, getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';

import WEventlevelCell from '@/components/table/EventlevelCell';
import WLogDetailPopup from '../popup/LogDetailPopup';
import WDetailEventChart from './DetailEventChart';
import WDetailEventComment from './DetailEventComment';
import WDetailEventHist from './DetailEventHist';
import eventConstants from './js/event-constant';

export default {
  name: 'WAlarmDetail',
  components: {
    WLogDetailPopup,
    WDetailEventChart,
    WDetailEventComment,
    WDetailEventHist,
    WEventlevelCell,
  },
  props: {
    eventDetailShow: Boolean,
    eventData: Array,
    selectedEvent: Object,
    nowIndex: Number,
    active: Boolean,
  },
  data() {
    return {
      columnDefault,
      preBtnFlag: Boolean,
      nexBtnFlag: Boolean,
      moveIndex: Number,
      eventInfo: {
        eventInfo: {},
        eventSet: {},
      },
      eventLogs: [],
      eventLogColumns: [],
    };
  },
  watch: {
    active(value) {
      if (value) {
        this.eventLogColumns = [];
        this.getShowFields();
      }
    },
    selectedEvent: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value) && !isNil(value.eventSeq)) {
          this.eventInfo = value;
          this.loadEventLogs(value);
        }
      },
    },
    nowIndex: {
      immediate: true,
      handler(value) {
        this.moveIndex = clone(value);
      },
    },
    moveIndex(value) {
      const eventData = this.eventData;
      if (value > 0 && eventData.length > 1 && eventData.length - 1 !== value) {
        this.preBtnFlag = true;
        this.nexBtnFlag = true;
      } else if (value < 1 && eventData.length > 1) {
        this.preBtnFlag = false;
        this.nexBtnFlag = true;
      } else {
        this.preBtnFlag = eventData.length !== 1;
        this.nexBtnFlag = false;
      }
    },
  },
  methods: {
    getDateToString,
    /**
     * 테이블 컬럼용 Show field 목록을 조회해온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    getShowFields() {
      LogAPI.getLogShowFields().then((response) => {
        if (response.data.success) {
          const showFields = response.data.data;
          this.$nextTick(() => {
            if (!isEmpty(showFields)) {
              forEach(showFields, (item) => {
                this.eventLogColumns.push({
                  label: item.fieldName,
                  prop: item.fieldId,
                  width: this.getColumnWidth(item.fieldId),
                  formatter: item.fieldId === 'timestamp' ? this.getDateFormatter : this.getStringFormatter,
                  // className: item.fieldId === this.eventInfo.eventInfo.eventCondition ? 'marker' : null,
                  // showOverflowTooltip: true,
                });
              });
              this.eventLogColumns.push({ label: '상세보기', width: 70, scopedSlot: 'log-detail-slot', align: 'center' });
            }
          });
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필드 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 발생횟수/미확인패턴 발생 알람일 경우 해당 알람을 발생시킨 로그 메시지 목록을 조회해온다. (발생시각 전후 1분 이내 로그 기록들 > 추후 조건 수정 필요)
     * @author Minyeong
     * @param  {[type]} eventType [description]
     * @return {[type]}           [description]
     */
    loadEventLogs(eventInfo) {
      const startDateTime = getIntervalDatetimeParams(eventInfo.checkDatetime, 'hour', 24);
      const endDateTime = eventInfo.checkDatetime;
      let params;
      if (eventInfo.eventInfo.eventType === eventConstants.EVENT_TYPE.KEYWORD_COUNT) {
        params = {
          type: 'dataindex',
          dataindexId: eventInfo.eventInfo.dataindexId,
          queryList: [{ field: eventInfo.eventInfo.eventCondition, value: eventInfo.eventInfo.eventValue, regex: 'N', operator: 'AND' }],
          startDateTime: this.getStartDatetime(this.eventInfo),
          endDateTime: eventInfo.checkDatetime,
          start: 0,
          limit: eventInfo.eventOccurCondition > 100 ? 100 : eventInfo.eventOccurCondition,
        };
        LogAPI.getLogDatas(params).then((response) => {
          if (response.data.data) {
            this.eventLogs = response.data.data;
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그', false));
          throw new Error(e);
        });
      } else if (eventInfo.eventInfo.eventType === eventConstants.EVENT_TYPE.UNKNOWN_PATTERN) {
        params = {
          type: 'root',
          queryList: [{ field: 'mlPatternId', value: 0, regex: 'N', operator: 'AND' }],
          startDateTime,
          endDateTime,
          start: 0,
          limit: eventInfo.eventOccurCondition > 100 ? 100 : eventInfo.eventOccurCondition,
        };
        LogAPI.getLogDatas(params).then((response) => {
          if (response.data.data) {
            this.eventLogs = response.data.data;
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그', false));
          throw new Error(e);
        });
      } else if (eventInfo.eventInfo.eventType === eventConstants.EVENT_TYPE.ML_PATTERN) {
        params = {
          type: 'dataindex',
          dataindexId: eventInfo.eventInfo.dataindexId,
          queryList: [{ field: 'mlPatternId', value: eventInfo.eventInfo.eventValue, regex: 'N', operator: 'AND' }],
          startDateTime: this.getStartDatetime(this.eventInfo),
          endDateTime: eventInfo.checkDatetime,
          start: 0,
          limit: eventInfo.eventOccurCondition > 100 ? 100 : eventInfo.eventOccurCondition,
        };
        LogAPI.getLogDatas(params).then((response) => {
          if (response.data.data) {
            this.eventLogs = response.data.data;
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그', false));
          throw new Error(e);
        });
      }
    },
    /**
     * [목록보기 버튼] 클릭 시 알람 상세정보 화면을 비활성화한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    showEventList() {
      this.$emit('load-data');
      this.$emit('update:eventDetailShow', false);
    },
    /**
     * [이전/다음 이동 버튼] 클릭 시 이전/다음 알람 상세정보를 요청해 조회해온다.
     * @author Minyeong
     * @param  {[type]} pageType [description]
     * @return {[type]}          [description]
     */
    clickForChangeTargetGroup(pageType) {
      let targetAlarm;
      if (pageType === 'pre') {
        this.moveIndex -= 1;
        targetAlarm = this.eventData[this.moveIndex];
      } else {
        this.moveIndex += 1;
        targetAlarm = this.eventData[this.moveIndex];
      }
      this.$emit('click-event-subject', targetAlarm);
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(getIntervalDatetimeParams(value, 'hour', 9), 'YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },
    getStringFormatter(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    /**
     * 동적 컬럼의 Width를 설정한다.
     * @author Minyeong
     * @param  {[type]} fieldId [description]
     * @return {[type]}         [description]
     */
    getColumnWidth(fieldId) {
      if (fieldId === 'originMessage') {
        return 800;
      } else if (fieldId === 'timestamp') {
        return 160;
      }
      return null;
    },
    /**
     * 알람 종류가 발생횟수(키워드/머신러닝 패턴)일 경우 로그를 조회할 startDatetime을 반환한다.
     * @author Minyeong
     * @param  {[type]} eventInfo [description]
     * @return {[type]}           [description]
     */
    getStartDatetime(eventInfo) {
      const startDatetime = new Date(eventInfo.checkDatetime);
      if (eventInfo.eventSet.eventcheckTimeUnit === eventConstants.TIME_INTERVAL.S) {
        startDatetime.setSeconds(startDatetime.getSeconds() - eventInfo.eventSet.eventcheckTime);
      } else if (eventInfo.eventSet.eventcheckTimeUnit === eventConstants.TIME_INTERVAL.M) {
        startDatetime.setMinutes(startDatetime.getMinutes() - eventInfo.eventSet.eventcheckTime);
      } else if (eventInfo.eventSet.eventcheckTimeUnit === eventConstants.TIME_INTERVAL.H) {
        startDatetime.setHours(startDatetime.getHours() - eventInfo.eventSet.eventcheckTime);
      } else if (eventInfo.eventSet.eventcheckTimeUnit === eventConstants.TIME_INTERVAL.D) {
        startDatetime.setDate(startDatetime.getDate() - eventInfo.eventSet.eventcheckTime);
      }
      return startDatetime.getTime();
    },
    openDetailPopup(log) {
      this.$refs.logDetailPopup.open(log);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/log-analysis/Event/EventDetail.vue